import {LS_USER, SS_TOKEN} from "../common/constants/storages";
import { selectAdcGame, selectClassicGame, selectTournament } from "../pages/Darts/EventManager/DartsEventManager.slice";
import { AppDispatch } from "../store";
import { clearLoginState } from "../pages/Auth/Auth.slice";
import { NavigateFunction } from "react-router-dom";
import { LOGIN } from "../common/routes";

export const handleLogout = (dispatch: AppDispatch, navigate: NavigateFunction) => {
    sessionStorage.removeItem(SS_TOKEN);
    localStorage.removeItem(LS_USER);
    dispatch(selectClassicGame(0));
    dispatch(selectAdcGame(0));
    dispatch(selectTournament(0));
    dispatch(clearLoginState())
    sessionStorage.clear();
    navigate(LOGIN);
};
